import { fetchBackend } from './apiClient';

export type MessageHistory = {
  content: string;
  role: 'user' | 'assistant';
}[];

export const chatWithAnnieBackend = async ({
  projectId,
  prompt,
  conversationId,
  history,
  messageId,
}: {
  projectId: string;
  prompt: string;
  conversationId: string;
  history: MessageHistory;
  messageId: string;
}): Promise<void> => {
  const postResponse = await fetchBackend(`/annie/${projectId}/chat`, {
    method: 'POST',
    body: JSON.stringify({
      prompt,
      history,
      conversationId,
      messageId,
    }),
  });

  if (!postResponse.ok) {
    throw new Error(`Error: ${postResponse.statusText}`);
  }
};

export const callAnnieRCA = async ({
  projectId,
  prompt,
  history,
  incidentResolutionId,
  incidentId,
}: {
  projectId: string;
  prompt: string;
  history: MessageHistory;
  incidentResolutionId: string;
  incidentId: string;
}): Promise<void> => {
  const postResponse = await fetchBackend(`/annie/${projectId}/rca`, {
    method: 'POST',
    body: JSON.stringify({
      prompt,
      history,
      incidentResolutionId,
      incidentId,
      // TODO - Is it really useful ?
      conversationId: crypto.randomUUID(),
      messageId: crypto.randomUUID(),
    }),
  });

  if (!postResponse.ok) {
    throw new Error(`Error: ${postResponse.statusText}`);
  }
};

export const startIncidentResolution = async ({
  projectId,
  incidentId,
}: {
  projectId: string;
  incidentId: string;
}): Promise<void> => {
  const postResponse = await fetchBackend(
    `/annie/${projectId}/start-resolution`,
    {
      method: 'POST',
      body: JSON.stringify({
        incidentId,
        // TODO - Is it really useful ?
        conversationId: crypto.randomUUID(),
        messageId: crypto.randomUUID(),
      }),
    },
  );

  if (!postResponse.ok) {
    throw new Error(`Error: ${postResponse.statusText}`);
  }
};
